<template>
  <div class="after-sale">
    <div class="section-title">售后/退款</div>

    <div class="after-sale-tabs">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="全部" name="all">
          <empty-component text="暂无售后/退款信息"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="处理中" name="processing">
          <empty-component text="暂无处理中的售后/退款"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="已处理" name="processed">
          <empty-component text="暂无已处理的售后/退款"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'AfterSale',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'all'
    }
  },
  created() {
    // 从路由参数获取初始 tab
    const { tab } = this.$route.query
    if (tab) {
      this.activeTab = tab
    }
  }
}
</script>

<style lang="scss" scoped>
.after-sale {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .after-sale-tabs {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
